import React from 'react';
import './CustomSearchField.scss';

interface IProps {
    data: any
    searchQuery: any
    guestUserUrlLink : any
}

const CustomSearchField = (props: IProps) => {
    const { guestUserUrlLink } = props;   
    const filteredData = props.data?.map((item: any) => {
        return {
            key: item.id,
            categoryId: item.salesHierarchy,
            label: item.globalSearchCategoryName,
            values: item.globalSearchSuggestions?.map((t: any) => ({key:t.id, partNumber: t.partNumber, name: `${t.partNumber} ${t.name} (${t.partNumber})`}) ),
            };
    })

    const redirectToPartCategory = (category: any) => {
        window.location.href = `${guestUserUrlLink?.mvcGuestUserPartStoreUrl}?categoryId=${category?.categoryId}`;
    }

    const redirectToPartNumber = (part: any) => {
        window.location.href = `${guestUserUrlLink?.mvcGuestUserPartStoreUrl}?partNumber=${part?.partNumber}`;
    }


    return (
        <div className="page_Wrapper">
            <div>
                {props.searchQuery.length >= 3 && filteredData.length > 0 && (
                    <div className="Search_Container">
                        {filteredData.map((item: any) => (
                            <>
                                <div key={item.key}>
                                    <div className="group_label" onKeyDown={() => { }} onClick={() => redirectToPartCategory(item)}>{item.label}</div>
                                    <ul>
                                        {item.values.map((part: any) => (
                                            <li key={part.key}>
                                                <p onKeyDown={() => { }} onClick={() => redirectToPartNumber(part)}>{part.name}</p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="matchesfound">
                                    <span>{item.matches}</span>
                                </div>
                            </>
                        ))}
                    </div>
                )}

                {props.searchQuery.length >= 1 && props.searchQuery.length <= 2 && (
                    <div className="Search_Container">Please enter 3 or more Characters</div>
                )}

                {props.searchQuery.length >= 3 && filteredData.length === 0 && (
                    <div className="Search_Container">No results found</div>
                )}
            </div>
        </div>
    )
}

export default CustomSearchField